<template>
    <div class="joinIndex">
        <div class="text">
            <div class="title">{{getIndexData.fixedFieldMap['joinUs.joinUs']}}</div>
            <div class="eng">Honorany award</div>
            <div class="des">
                {{getIndexData.fixedFieldMap['joinUs.content1']}}
            </div>
            <div class="des">
                {{getIndexData.fixedFieldMap['joinUs.content']}}
            </div>
        </div>
        <div class="item-w">
            <div class="item" v-for='(i,k) in data' :key='k'>
                <div class="date">{{i.createTime | formatTime}}</div>
                <div class="name">{{i.position}}</div>
                <div class="line"></div>
                <!--<div class="condition">任职要求</div>-->
                <!--<div class="condition-item">{{i.requirements}}</div>-->
                <div class="more" @click="detail(i)">{{langType=='zh'?'了解更多':'Read More'}}</div>
            </div>
        </div>
    </div>
</template>


<script>
import { formatTime } from '@/utils'
import {mapGetters} from 'vuex'
export default {
    data: () => ({
        langType: 'zh'
    }),
    computed: {
      ...mapGetters(['getIndexData']),
    },
    filters: {
        formatTime
    },
    props: {
        data: Array,
    },
    created(){
        this.langType = localStorage.getItem('langType')
    },
    methods: {
        detail (data) {
            this.$emit('detail', data)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "~styl/mixin.styl"

theme = #f7aa05

.joinIndex
    mt(20)
    .item-w 
        _flex()
        flex-wrap wrap
        mt(50)
        .item 
            padding 20px
            box()
            width 22%
            mb(30)
            border-radius 0 0 20px 0
            border 1px solid gray
            &:hover 
                cursor pointer
            .date 
                fs(14)
                c(gray)
            .name 
                fs(18)
                font-weight 700
                c(theme)
                pt(10)
                pb(10)
            .line 
                h(2)
                bg(#333)
                mb(15)
                border-radius 4px
            .condition 
                fs(13)
                c(gray)
                pb(20)
            .condition-item 
                multiTextover(2)
                fs(13)
                c(gray)
            .more 
                lh(32)
                w(145)
                border-radius 14px
                ta(center)
                fs(14)
                c(gray)
                mt(30)
                mb(10)
                border 1px solid gray
    .text 
        ta(center)
        .title 
            fs(19)
        .eng 
            pt(5)
            fs(16)
            c(gray)
            pb(30)
        .des 
            fs(14)
            c(gray)

            

</style>



// WEBPACK FOOTER //
// src/components/join/default.vue